import { translate } from '@jsverse/transloco';
export enum FrameworkStatus {
    UNPUBLISHED = 'UNPUBLISHED',
    PUBLISHED = 'PUBLISHED',
    INACTIVE = 'INACTIVE',
}

export class FrameworkStatusHelper {
    static getFrameworkStatusLocale(status: FrameworkStatus): string {
        switch (status) {
            case FrameworkStatus.UNPUBLISHED:
                return translate('CORE.FRAMEWORK_STATUSES.UNPUBLISHED');
            case FrameworkStatus.PUBLISHED:
                return translate('CORE.FRAMEWORK_STATUSES.PUBLISHED');
            case FrameworkStatus.INACTIVE:
                return translate('CORE.FRAMEWORK_STATUSES.INACTIVE');
            default:
                return status;
        }
    }
}
